import React from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { ProductCard } from "../global/ProductCard";

export const BestSeller = ({ data }) => {
  const result = Array.isArray(data)
    ? [...data].sort((a, b) => b.count - a.count).slice(0, 8)
    : [];

  const SectionHeader = (
    <Box
      sx={{
        px: { xs: 2, sm: 4, md: 6, lg: 10 },
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        mb: { xs: 2.5, md: 4 },
      }}
    >
      <Typography sx={{ fontSize: { xs: 20, md: 30 }, fontWeight: 300, letterSpacing: "-0.03em", color: "#111827" }}>
        Best Sellers
      </Typography>
      <Link to="/shop" style={{ textDecoration: "none" }}>
        <Typography sx={{ fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", color: "#6b7280", borderBottom: "1px solid #9ca3af", pb: 0.25 }}>
          View All
        </Typography>
      </Link>
    </Box>
  );

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, bgcolor: "#f9fafb" }}>
      {SectionHeader}

      {/* Mobile: horizontal scroll slider */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          gap: 1.5,
          overflowX: "auto",
          scrollSnapType: "x mandatory",
          px: 2,
          pb: 1.5,
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
        }}
      >
        {result.map((item, index) => (
          <Box
            key={index}
            sx={{ flexShrink: 0, width: { xs: "72vw", sm: "36vw" }, scrollSnapAlign: "start" }}
          >
            <ProductCard
              id={item.id}
              imgSrc={item.imgSrc}
              title={item.name}
              path={`/shop/view/${item.slug}/${item.id}`}
              price={item.price}
              slug={item.slug}
              limit={item.stock}
            />
          </Box>
        ))}
      </Box>

      {/* Desktop: 4-column grid */}
      <Box sx={{ display: { xs: "none", md: "block" }, px: { md: 6, lg: 10 } }}>
        <Grid container spacing={2.5}>
          {result.map((item, index) => (
            <Grid item md={3} key={index}>
              <ProductCard
                id={item.id}
                imgSrc={item.imgSrc}
                title={item.name}
                path={`/shop/view/${item.slug}/${item.id}`}
                price={item.price}
                slug={item.slug}
                limit={item.stock}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
